document.addEventListener("DOMContentLoaded", function () {
    var menu_items = document.querySelectorAll('.food-menu-item');

    [].forEach.call(menu_items, function(menu_item) {
        menu_item.addEventListener('click', event => {

            [].forEach.call(menu_items, function(tmp_item) {
                let tmp_li_elem = tmp_item.parentNode;
                tmp_li_elem.classList.remove("menu-active");
                tmp_li_elem.getElementsByTagName('span')[0].classList.add("opacity-0");
            });

            let li_elem = menu_item.parentNode;
            li_elem.classList.add("menu-active");
            li_elem.getElementsByTagName('span')[0].classList.remove("opacity-0");
        })
    });

});
